import {AutoMap} from '@automapper/classes';
import {
  TBaseGetAllResponseDto,
  TBaseGetResponseDto,
} from './common/t-base-response.dto';
import {
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseCreateRequestDto,
  TBaseUpdateRequestDto,
} from './common/t-base-request.dto';
import {ReviewSessionStatusEnum} from '../enums/review-session-status.enum';
import {ReviewSessionItemStatusEnum} from '../enums/review-session-item-status.enum';
import {ReviewSessionOrderingTypeEnum} from '../enums/review-session-ordering-type.enum';

export class ReviewSessionGetAllRequestDto extends TBaseGetAllRequestDto {
}

export class ReviewSessionGetRequestDto extends TBaseGetRequestDto {
}

export class ReviewSessionCreateRequestDto extends TBaseCreateRequestDto {
  @AutoMap()
  cardCount!: number;

  @AutoMap()
  orderingType!: ReviewSessionOrderingTypeEnum;

  @AutoMap(() => String)
  sourceIds!: string[];
}

export class ReviewSessionUpdateRequestDto extends TBaseUpdateRequestDto {
  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  completedOn!: Date | null;
}

export class ReviewSessionItemUpdateRequestDto {
  @AutoMap()
  id!: string;

  @AutoMap()
  status!: ReviewSessionItemStatusEnum;

  @AutoMap()
  seenOn!: Date;

  @AutoMap()
  durationMs!: number;
}

export class ReviewSessionGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  isSystemReminder!: boolean;

  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  startedOn!: Date;

  @AutoMap()
  completedOn!: Date;

  @AutoMap()
  totalSeen!: number;

  @AutoMap()
  totalReviewed!: number;

  @AutoMap()
  totalSkipped!: number;

  @AutoMap(() => String)
  sourceTitles!: string[];
}

export class ReviewSessionGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  isSystemReminder!: boolean;

  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  startedOn!: Date;

  @AutoMap()
  completedOn!: Date | null;

  @AutoMap()
  totalSeen!: number;

  @AutoMap()
  totalReviewed!: number;

  @AutoMap()
  totalSkipped!: number;

  @AutoMap()
  items!: ReviewSessionItemGetResponseDto[];

  @AutoMap()
  sources!: ReviewSessionSourceGetResponseDto[];
}

export class ReviewSessionResetRequestDto extends TBaseUpdateRequestDto {

}

export class ReviewSessionItemGetResponseDto {
  @AutoMap()
  id!: string;

  @AutoMap()
  highlightId!: string;

  @AutoMap()
  highlightText!: string;

  @AutoMap()
  sourceTitle!: string;

  @AutoMap()
  status!: ReviewSessionItemStatusEnum;

  @AutoMap()
  seenOn!: Date | null;

  @AutoMap()
  durationMs!: number | null;
}

export class ReviewSessionSourceGetResponseDto {
  @AutoMap()
  sourceId!: string;

  @AutoMap()
  title!: string;
}
